// Generated by scripts/update-seeq-icons.js from src/svg/seeq/short-dash.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcShortDash = {
  prefix: 'fak',
  iconName: 'short-dash' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f901',
    'M368.6 512h307.2v46.1h-307.2v-46.1zM762.9 512h261.1v46.1h-261.1v-46.1zM368.6 465.9h307.2v46.1h-307.2v-46.1zM0 512h281.6v46.1h-281.6v-46.1zM0 465.9h281.6v46.1h-281.6v-46.1zM762.9 465.9h261.1v46.1h-261.1v-46.1z',
  ],
} satisfies IconDefinition;
